import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			aboutAboutHeliumMriContentSectionHeaderCls: string;
			aboutAboutHeliumMriContentSectionTextInnerCls: string;
		}
	},

	slug: string
}

class Mri extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('About About Helium Mri Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.aboutAboutHeliumMriContentSectionHeaderCls || '','about_about_helium_mri', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.aboutAboutHeliumMriContentSectionTextInnerCls || '','about_about_helium_mri', { animCls: 'animate__fadeInRight25P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Mri;